module.exports = __webpack_public_path__ + "img/17848_L.7f03d12e.png";